import { getMMT_HLD_OBJ } from './appUtils';

export const getVerIdentifierBodyForDetails = currentBody => {
  if (getMMT_HLD_OBJ()?.acmeV3) {
    return {
      ...currentBody,
      verIdentifier: 'v3',
    };
  }
  return {
    ...currentBody,
  };
};

export const getAPWindow = date =>
  `AP_${Math.floor((new Date(date) - Date.now()) / (1000 * 60 * 60 * 24))}`;
